import jwt from 'jsonwebtoken';
import store from './store';

/**
 * @returns {object | boolean}
 */
export function getUser() {
  if (getAccessToken()) {
    const decodedAccessToken = jwt.decode(getAccessToken());
    return decodedAccessToken.user;
  }
  return false;
}

/**
 * @returns {object | null}
 */
export function getAccessToken() {
  return localStorage.getItem('access_token');
}

/**
 * @returns {string | null}
 */
export function getRefreshToken() {
  return localStorage.getItem('refresh_token');
}

/**
 * @param accessToken
 * @param refreshToken
 */
export function saveTokens(accessToken, refreshToken) {
  if (accessToken) {
    localStorage.setItem('access_token', accessToken);
  }
  if (refreshToken) {
    localStorage.setItem('refresh_token', refreshToken);
  }
}

/**
 * Removes the currently set access token from the localStorage
 */
export function clearAccessToken() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}

/**
 * @param {string} permission
 * @returns {boolean}
 */
export function hasUserPermission(permission) {
  const user = getUser();

  if (!user) {
    return false;
  }

  return user.permissions.indexOf(permission) !== -1;
}

/**
 * @param {array} permissions
 * @returns {boolean}
 */
export function hasUserAnyOfThesePermissions(permissions) {
  const user = getUser();

  if (!user) {
    return false;
  }

  let foundMatch = false;

  permissions.forEach((requiredPermission) => {
    if (!foundMatch && user.permissions.indexOf(requiredPermission) !== -1) {
      foundMatch = true;
    }
  });

  return foundMatch;
}

export function hasAnyOfTheseRoles(roles) {
  let foundMatch = false;

  roles.forEach((requiredRole) => {
    if (!foundMatch && store.state.user.roles.indexOf(requiredRole) !== -1) {
      foundMatch = true;
    }
  });

  return foundMatch;
}

/**
 * @param {array} permissions
 * @returns {boolean}
 */
export function hasUserAllOfThesePermissions(permissions) {
  const user = getUser();

  if (!user) {
    return false;
  }

  return permissions.every((requiredPermission) => {
    return user.permissions.indexOf(requiredPermission) !== -1;
  });
}

/**
 * Returns, if the user is logged in.
 *
 * @returns {boolean}
 */
export function isUserLoggedIn() {
  return store.state.loggedIn;
}
